// eventBus.js
const listeners = [];

export const addListener = (fn) => listeners.push(fn);
export const removeListener = (fn) => {
  const index = listeners.indexOf(fn);
  if (index > -1) listeners.splice(index, 1);
};

export const dispatchMessage = (message) => {
  listeners.forEach(fn => fn(message));
};